




import { Component } from "vue-property-decorator";
import Vue from "vue";
import { FormFields, ListFields } from "@/types";
import { $t } from "@/lib/helpers/i18nHelper";
import QueryFilter from "@/components/QueryFilter.vue";
import config from "@/config";

@Component({
  name: "UserListFilter",
  components: { QueryFilter },
})
export default class UserListFilter extends Vue {
  public get fields(): FormFields {
    const roleList: ListFields = [
      { text: $t("All Users"), value: null },
      ...config.userRoleList.sort().map(role => ({ text: this.$tc($t(role), 10, { withoutN: true }), value: role })),
    ];
    const sortList: ListFields = [
      {
        text: $t("Registration time"),
        value: null,
      },
      {
        text: $t("Last login time"),
        value: "LAST_LOGIN_TIME,DESC",
      },
      {
        text: $t("Last online time"),
        value: "LAST_ONLINE_TIME,DESC",
      },
    ];

    return [
      {
        name: "term",
        title: $t("Quick Search"),
        flexClass: "px-6 col-12 col-md-4",
        placeholder: $t("Put here ID, name, email or IP"),
        clearable: true,
      },
      {
        name: "role",
        title: $t("Show"),
        flexClass: "px-6 col-12 col-sm-6 col-md-4",
        list: roleList,
        type: "select",
        clearable: false,
      },
      {
        name: "sort",
        title: $t("Sort By"),
        flexClass: "px-6 col-12 col-sm-6 col-md-4",
        list: sortList,
        type: "select",
        clearable: false,
      },
    ];
  }
}
